import { Skeleton, Box } from "@mui/material";

const EventCardSkeleton = () => (
  <Box sx={{ width: "100%", p: 2 }}>
    <Skeleton variant="rectangular" width="100%" height={120} />
    <Box sx={{ pt: 0.5 }}>
      <Skeleton width="60%" />
      <Skeleton width="40%" />
      <Skeleton width="30%" />
    </Box>
  </Box>
);

export default EventCardSkeleton;